import classes from './CustomTextField.module.css';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  value: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  disabled?: boolean;
  maxWidth?: string;
  height?: string;
  type?: string;
  biomarkerValues?: BiomarkerValues;
  errorValidation?: boolean;
  required?: boolean;
  unit?: string;
  labelColor?: string;
  optional?: boolean;
}

type BiomarkerValues = {
  value1?: number;
  value2?: number;
};

const CustomTextField: React.FC<Props> = ({
  label,
  value,
  onChange,
  disabled,
  maxWidth,
  height,
  type,
  biomarkerValues,
  errorValidation,
  required,
  unit,
  labelColor,
  optional,
  ...props
}) => {
  return (
    <div
      className={classes.container}
      style={{
        maxWidth: maxWidth ?? '100%',
        height: height ?? 70,
      }}
    >
      {label && (
        <div className={classes.labelContainer}>
          <div className={classes.label} style={labelColor ? { color: `${labelColor}` } : {}}>
            {label} <span className={classes.optional}>{optional && '(optional)'}</span>
          </div>
          {required && <div className={classes.labelAsterix}>*</div>}
        </div>
      )}
      <input
        lang={'de_DE'}
        disabled={disabled}
        className={!errorValidation ? classes.input : classes.errorInput}
        required={required}
        value={value || ''}
        onChange={onChange}
        type={type ?? 'text'}
        {...props}
      />
      {biomarkerValues && (
        <div
          className={classes.helper}
        >{`${biomarkerValues.value1} - ${biomarkerValues.value2}`}</div>
      )}
      {unit && <div className={classes.unit}>{unit}</div>}
    </div>
  );
};

export default CustomTextField;
